import type {Module} from "vuex";
import type {RootState} from "@/store/types";

export type WidgetOptions = Record<string, unknown>

export interface WidgetState {
    display: boolean
    options: WidgetOptions
}

const widget: Module<WidgetState, RootState> = {
    namespaced: true,
    state: {
        display: true,
        options: {}
    },
    getters: {
        display: (state): boolean => state.display,
        options: (state): WidgetOptions => state.options
    },
    mutations: {
        setDisplay: (state, display: boolean) => state.display = display,
        setOptions: (state, options: WidgetOptions) => state.options = options,
        clearOptions: state => state.options = {}
    },
    actions: {
        setDisplay: (context, display: boolean) => context.commit("setDisplay", display),
        setOptions: (context, options: WidgetOptions) => context.commit("setOptions", options),
        clearOptions: (context) => context.commit("clearOptions"),
    }
}

export default widget
